// TimeConverter.js
import React from 'react';

const TimeConverter = ({ utcDateString }) => {
    const convertToUAETime = (utcDateString) => {
        // Create a date object from the UTC date string
        const date = new Date(utcDateString + 'Z'); // Append 'Z' to indicate UTC time

        // Convert to UAE time (UTC+4)
        const options = {
            timeZone: 'Asia/Dubai', // UAE Time Zone
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true // 12-hour format
        };

        // Format the date to the desired format
        const formatter = new Intl.DateTimeFormat('en-GB', options);
        const parts = formatter.formatToParts(date);

        // Extract the parts and format them
        const day = parts.find(part => part.type === 'day').value;
        const month = parts.find(part => part.type === 'month').value;
        const year = parts.find(part => part.type === 'year').value;
        const hour = parts.find(part => part.type === 'hour').value;
        const minute = parts.find(part => part.type === 'minute').value;
        const ampm = parts.find(part => part.type === 'dayPeriod').value;

        // Return the formatted date string
        return `${day}-${month}-${year} ${hour}:${minute} ${ampm}`;
    };

    const formattedTime = convertToUAETime(utcDateString);

    return (
        <span>{formattedTime}</span>
    );
};

export default TimeConverter;